import { render } from "./actions-tab.vue?vue&type=template&id=5cc31b7e&scoped=true"
import script from "./actions-tab.vue?vue&type=script&lang=js"
export * from "./actions-tab.vue?vue&type=script&lang=js"

import "./actions-tab.vue?vue&type=style&index=0&id=5cc31b7e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cc31b7e"]])

export default __exports__